import { useCallback, useEffect, useState } from "react";

import { comandasApi } from "./api";

/** As comandas abertas da loja, atualizadas a cada 10 s (outro aparelho pode abrir ou fechar). */
export function useComandas(ativo = true, intervaloMs = 10000) {
  const [abertas, setAbertas] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const recarregar = useCallback(async () => {
    try {
      const lista = await comandasApi.listar("aberta");
      setAbertas(Array.isArray(lista) ? lista : []);
    } catch { /* mantém a lista que tinha */ } finally {
      setCarregando(false);
    }
  }, []);
  useEffect(() => {
    if (!ativo) return undefined;
    recarregar();
    const i = setInterval(recarregar, intervaloMs);
    return () => clearInterval(i);
  }, [ativo, intervaloMs, recarregar]);
  return { abertas, carregando, recarregar };
}
